import { getIntegrationStatusByInternalName } from 'lib/api/integrations';
import {
  hasAnySettingsAccountingCompanyType,
  hasAnySettingsFinanceCompanyType,
  hasAnySettingsProductsCompanyType,
  hasAnySettingsRiskCompanyType,
  hasAnySettingsSiiCompanyType,
  hasAnySettingsTagsCompanyType,
  hasAnySettingsUsersCompanyType,
} from 'lib/companyTypeChecks/settings';
import {
  hasAnySettingsAccountingPermissions,
  hasAnySettingsFinancePermissions,
  hasAnySettingsProductsPermissions,
  hasAnySettingsRiskPermissions,
  hasAnySettingsSiiPermissions,
  hasAnySettingsTagsPermissions,
  hasAnySettingsUsersPermissions,
} from 'lib/permissionChecks/settings';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import CenteredCircularProgress from '../../lib/designSystem/CircularProgress';
import EnhancedTab from '../../lib/designSystem/TabSimulation';
import { AuthState } from '../../services/redux/authSlice';
import AccountingTab from './Components/Accounting';
import Contracts from './Components/Contracts';
import FinanceTab from './Components/Finance';
import Products from './Components/Products';
import RiskTab from './Components/Risk';
import SettingsSii from './Components/SII';
import TagsSettings from './Components/Tags';
import UsersSettings from './Components/Users';

const companyTabs = [
  {
    label: 'Usuarios',
    component: <UsersSettings />,
    mainPage: 'users',
    subPage: 'summary',
    index: 0,
  },
  {
    label: 'Productos',
    component: <Products />,
    mainPage: 'products',
    subPage: 'summary',
    index: 1,
  },
  {
    label: 'Riesgo',
    component: <RiskTab />,
    mainPage: 'risk',
    subPage: 'engines',
    index: 2,
  },
  {
    label: 'Finanzas',
    component: <FinanceTab />,
    mainPage: 'finance',
    subPage: 'collections',
    index: 3,
  },
  {
    label: 'SII',
    component: <SettingsSii />,
    mainPage: 'sii',
    subPage: 'certificates',
    index: 4,
  },
  {
    label: 'Tags',
    component: <TagsSettings />,
    mainPage: 'tags',
    subPage: 'categories',
    index: 5,
  },
  {
    label: 'Contabilidad',
    component: <AccountingTab />,
    mainPage: 'accounting',
    subPage: 'nodes',
    index: 6,
  },
  {
    label: 'Contratos',
    component: <Contracts />,
    mainPage: 'contracts',
    subPage: 'portfolios',
    index: 7,
  },
];

const AdminDashboard: React.FC = () => {
  const dispatch = useDispatch();
  const { mainPage } = useParams<{ page: string; mainPage: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [compnayTabs, setCompanyTabs] = useState(companyTabs);
  const [startValue, setStartValue] = useState(0);

  const handleNavigation = (index: number) => {
    navigate(
      `/settings/${companyTabs[index].mainPage}/${companyTabs[index].subPage}`,
    );
  };
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const setTabs = async () => {
    setLoading(true);
    const { status: hasDigitalSignature } =
      await getIntegrationStatusByInternalName(dispatch, 'digital-signature');

    const newCompanyTabs = [];

    if (
      hasAnySettingsUsersCompanyType(user) &&
      hasAnySettingsUsersPermissions(user)
    ) {
      newCompanyTabs.push(companyTabs[0]);
    }
    if (
      hasAnySettingsProductsCompanyType(user) &&
      hasAnySettingsProductsPermissions(user)
    ) {
      newCompanyTabs.push(companyTabs[1]);
    }
    if (
      hasAnySettingsRiskCompanyType(user) &&
      hasAnySettingsRiskPermissions(user)
    ) {
      newCompanyTabs.push(companyTabs[2]);
    }
    if (
      hasAnySettingsFinanceCompanyType(user) &&
      hasAnySettingsFinancePermissions(user)
    ) {
      newCompanyTabs.push(companyTabs[3]);
    }
    if (
      hasAnySettingsSiiCompanyType(user) &&
      hasAnySettingsSiiPermissions(user)
    ) {
      newCompanyTabs.push(companyTabs[4]);
    }
    if (
      hasAnySettingsTagsCompanyType(user) &&
      hasAnySettingsTagsPermissions(user)
    ) {
      newCompanyTabs.push(companyTabs[5]);
    }
    if (
      hasAnySettingsAccountingCompanyType(user) &&
      hasAnySettingsAccountingPermissions(user)
    ) {
      newCompanyTabs.push(companyTabs[6]);
    }
    if (hasDigitalSignature) {
      newCompanyTabs.push(companyTabs[7]);
    }

    setCompanyTabs(newCompanyTabs);

    const startValue = newCompanyTabs.findIndex(
      (x) => x.mainPage === `${mainPage}`,
    );

    setStartValue(startValue !== -1 ? startValue : 0);
    setLoading(false);
  };

  useEffect(() => {
    void setTabs();
  }, []);

  if (loading) return <CenteredCircularProgress type="layout" />;

  return (
    <div>
      <EnhancedTab
        title="Configuración"
        startValue={startValue}
        tabs={compnayTabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default AdminDashboard;
